import i18n from '../../../i18n';

export const DIAS_SEMANA = [
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
  'Domingo',
];
export const FECHA = 'fecha';
export const DIA_SEMANA = 'dia semana';
export const indicadores = {
  uptime: {
    name: 'uptime',
    axisConfig: {
      min: 0,
      max: 100,
      minColor: '#e6ffec',
      maxColor: '#9cffb6',
    },
    noData: -1,
    titleFecha: i18n.t('heatmap.graph.indicadores.uptime.title-fecha'),
    titleSemana: i18n.t('heatmap.graph.indicadores.uptime.title-semana'),
  },
  downtime: {
    name: 'downtime',
    axisConfig: {
      min: 0,
      max: 100,
      minColor: '#ffe8e9',
      maxColor: '#ff666c',
    },
    noData: -1,
    titleFecha: i18n.t('heatmap.graph.indicadores.downtime.title-fecha'),
    titleSemana: i18n.t('heatmap.graph.indicadores.downtime.title-semana'),
  },
};
export const CATEGORIAS = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
];
